/* Built In Imports */
/* External Imports */
import { Box, Flex, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import inProgressIcon from '@ieo/Components/ThankYou/assets/inProgressIcon.svg';
import ishaLogo from '@ieo/Components/ThankYou/assets/ishaLogo.svg';
import loadingIcon from '@ieo/Components/ThankYou/assets/loadingIcon.svg';

/* Services */

/**
 *
 * @returns
 */
export const TakingLongerScreen = () => {
  return (
    <Box maxW={'700px'} px={{ base: '20px', md: '80px' }} h={'full'}>
      <Flex
        maxW={'380px'}
        mx={'auto'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        textAlign={'center'}
        height={'full'}
        py={12}
      >
        <img src={inProgressIcon.src} width={54} height={54} />
        <Text fontSize={'22px'} color={'#CC9812'} mb={4} mt={2}>
          In progress
        </Text>
        <Flex
          flexDirection={'column'}
          gridGap={5}
          mb={8}
          fontFamily={'FedraSansStd-book'}
          fontSize={'18px'}
        >
          <Box as={'p'} fontFamily={'FedraSansStd-medium'}>
            The Transaction is taking longer than usual to progress.
          </Box>

          <p>
            You will receive an email confirmation once your transaction
            completes.
          </p>

          <p>
            Please reach out to{' '}
            <Link
              href={'https://support.ishafoundation.org/'}
              isExternal={true}
              color={'#E86F34'}
            >
              Support
            </Link>{' '}
            if you are facing further issues.
          </p>
        </Flex>
      </Flex>
    </Box>
  );
};

export const LoadingIndicator = ({ authStatus }) => {
  // console.log({ authStatus });
  if (authStatus === 'waited30s') {
    return <TakingLongerScreen />;
  }

  return (
    <Flex
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      height={'full'}
      pt={'70px'}
    >
      <Box mb={'74px'}>
        <img src={ishaLogo.src} width={76} height={62} />
      </Box>
      <Box mb={4}>
        <img src={loadingIcon.src} width={54} height={54} />
      </Box>
      <Box pb={20}>Transaction in Progress</Box>
    </Flex>
  );
};
